import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { IS_LOAD, IS_SEARCH } from 'src/app/shared/models/load.models';
import { QcMerchantResponse } from 'src/app/shared/models/qcResponse.model';
import { EnvironmentFacadeService } from 'src/app/shared/services/environment.facade.service';
import { LiteralsFacadeService } from 'src/app/shared/services/literals.facade.service';
import { PaginatorFacadeService } from 'src/app/shared/services/paginator.facade.service';
import { Couponset, LMembersResponse, Schema, Store } from '../models/members-search.models';
import { AllCustomersFacadeService } from './all-customers.facade.service';

@Injectable({ providedIn: 'root' })
export class AllCustomersService {
  constructor(
    private http: HttpClient,
    private environmentFacadeService: EnvironmentFacadeService,
    private acFacade: AllCustomersFacadeService,
    private paginatorFacade: PaginatorFacadeService,
    private literalsFacade: LiteralsFacadeService,
  ) {}

  schemas(): Observable<Schema[]> {
    const url = this.environmentFacadeService.getEnvironment() + '/rest/v1/loyalty/schemas';

    return this.http.get<Schema[]>(url, {
      withCredentials: true,
      context: new HttpContext().set(IS_LOAD, true),
    });
  }

  stores(): Observable<Store[]> {
    const url = this.environmentFacadeService.getEnvironment() + '/rest/v1/system/stores';

    return this.http.get<Store[]>(url, {
      withCredentials: true,
      context: new HttpContext().set(IS_LOAD, true),
    });
  }

  customer(): Observable<any> {
    const url = this.environmentFacadeService.getEnvironment() + '/rest/v1/tags/CUSTOMER';

    return this.http.get<any>(url, {
      withCredentials: true,
      context: new HttpContext().set(IS_LOAD, true),
    });
  }

  couponsets(): Observable<Couponset[]> {
    const url = this.environmentFacadeService.getEnvironment() + '/rest/v1/couponset';

    return this.http.get<Couponset[]>(url, {
      withCredentials: true,
      context: new HttpContext().set(IS_LOAD, true),
    });
  }

  attributeCodes(): Observable<QcMerchantResponse> {
    const url = this.environmentFacadeService.getEnvironment() + '/rest/v1/persons/attribute-codes';

    return this.http.get<QcMerchantResponse>(url, {
      withCredentials: true,
      context: new HttpContext().set(IS_LOAD, true),
    });
  }

  search(): Observable<LMembersResponse> {
    const url =
      this.environmentFacadeService.getEnvironment() +
      `/rest/v1/persons/findByFilter?start=${this.paginatorFacade.pageIndex * this.paginatorFacade.itemsNumber}&pageSize=${this.paginatorFacade.itemsNumber}&sortField=${this.paginatorFacade.selectedSortField === this.literalsFacade.literals.literals['liquid.search.sort.lastname'] ? 'LASTNAME' : this.paginatorFacade.selectedSortField === this.literalsFacade.literals.literals['liquid.search.sort.firstname'] ? 'FIRSTNAME' : 'REGISTRATION_DATE'}&sortOrder=${
        this.paginatorFacade.selectedOrder === this.literalsFacade.literals.literals['liquid.search.sort.asc']
          ? 'ASC'
          : 'DESC'
      }`;

    const body = this.getACBody();

    return this.http.post<LMembersResponse>(url, body, {
      withCredentials: true,
      context: new HttpContext().set(IS_SEARCH, true),
    });
  }

  count(): Observable<number> {
    const url = this.environmentFacadeService.getEnvironment() + '/rest/v1/persons/countByFilter';
    const body = this.getACBody();

    return this.http.post<number>(url, body, {
      withCredentials: true,
      context: new HttpContext().set(IS_SEARCH, true),
    });
  }

  getACBody() {
    let body: any = {
      lastName: this.acFacade.lastName ? this.acFacade.lastName.trim() : null,
      firstName: this.acFacade.firstName ? this.acFacade.firstName : null,
      includeInactive: this.acFacade.includeInactive,
      emailAddress: this.acFacade.email ? this.acFacade.email : null,
      mobile: this.acFacade.mobile ? this.acFacade.mobile : null,
      registrationDateFrom: this.acFacade.registrationDateFrom ? this.acFacade.registrationDateFrom : null,
      registrationDateUntil: this.acFacade.registrationDateUntil ? this.acFacade.registrationDateUntil : null,
      tagId: this.acFacade.memberTag ? this.acFacade.memberTag : null,
    };

    if (this.acFacade.attributeType) {
      const attributeValue =
        this.acFacade.attributeType === 'STRING' || this.acFacade.attributeType === 'INTEGER'
          ? this.acFacade.attributeValue
            ? this.acFacade.attributeValue
            : undefined
          : this.acFacade.attributeType === 'BOOLEAN'
            ? this.acFacade.attributeBoolValue
            : {
                dateFrom: this.acFacade.attributeDateFrom ? this.acFacade.attributeDateFrom : null,
                dateUntil: this.acFacade.attributeDateUntil ? this.acFacade.attributeDateUntil : null,
              };

      body.attribute = {
        attributeType: this.acFacade.attributeType,
        attributeName: this.acFacade.attributeName ? this.acFacade.attributeName : undefined,
        attributeValue: attributeValue ? attributeValue : undefined,
      };
    }

    if (this.acFacade.qivosID) {
      body.systemCode = this.acFacade.qivosID;
    }

    return body;
  }
}
